import React, { Component } from "react";
import { connect } from "react-redux";
import MainHeader from "../Header/header";
import MyFooter from "../Footer/footer";
import LandingHeader from "../Header/LandingHeader/landingheader";
import { Card, List, Row, Layout, Spin } from "antd";
import styled from "styled-components";
import RSSParser from "rss-parser";
//const RSSParser = require('rss-parser');
//import axios from 'axios'
//import 'rss-parser/dist/rss-parser.min.js';
//let Parser = require('rss-parser/dist/rss-parser.min.js');

const { Content } = Layout;

const Contentstyled = styled(Content)`
  position: relative;
`;

const SuperRow = styled(Row)`
  height: 100%;
`;
const CORS_PROXY = "https://cors-anywhere.herokuapp.com/";

class LandingHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      RSSLoaded: false
    };
    //this.getRSS
  }

  async componentDidMount() {
    var ctx = this;
    //  let parser = new RSSParser();
    RSSParser.parseURL(
      CORS_PROXY + "https://www.urbanlmfit.com/feed/",
      function(err, feed) {
        if(err) console.log(err)
        if(feed){
        ctx.feed = feed.feed;
        //console.log(ctx.feed.title);
        ctx.items = ctx.feed.entries;
        ctx.setState({ RSSLoaded: true });
      }
      }
    );
  }

  /*  async getRSS(){
  let feed = await parser.parseURL(CORS_PROXY + 'https://www.urbanlmfit.com/feed/');
  console.log(feed);
  console.log(feed.title)
  return(feed.items)

  feed.items.forEach(item => {
    return(<Row> {item.title} </Row>)
  });

  }
  */
  render() {
  //  console.log(this.state.RSSLoaded);
  //  console.log("mes items: ", this.items);
    if (this.state.RSSLoaded === true)
      return (
        <Layout style={{ minHeight: "100vh" }}>
          <MainHeader />
          <LandingHeader />
          <Contentstyled>
            <SuperRow style={{paddingTop: "10px", paddingBottom: "10px"}}>
              <h1 style={{ textAlign: "center" }}>
                {" "}
                Retrouvez ici toute l'actualité Urban Fitness !{" "}
              </h1>
            </SuperRow>
            <SuperRow type="flex">
              <List
                grid={{ gutter: 10, column: 1 }}
                dataSource={this.items}
                renderItem={item => (
                  <List.Item
                    key={item.title}
                    //actions={[<IconText type="star-o" text="156" />, <IconText type="like-o" text="156" />, <IconText type="message" text="2" />]}
                    //extra={<img width={272} alt="logo" src="https://gw.alipayobjects.com/zos/rmsportal/mqaQswcyDLcXyDKnZfES.png" />}
                  >
                    <Card
                      title={
                        <a href={item.link} target="_blank" rel="noopener noreferrer">
                          {item.title}{" "}
                        </a>
                      }
                      style={{ marginBottom: "15px" }}
                    >
                      <div dangerouslySetInnerHTML={{ __html: item.content }} />
                      Article écrit par {item.creator}
                    </Card>
                  </List.Item>
                )}
              />
            </SuperRow>
          </Contentstyled>
          <MyFooter />
        </Layout>
      );
    else
      return (
        <Layout style={{ minHeight: "100vh" }}>
          <MainHeader />
          <LandingHeader />
          <Contentstyled>
            <SuperRow>
            <Row
              style={{ marginTop: "200px" }}
              type="flex"
              justify="center"
              align="middle"
            >
              <Spin />
            </Row>
            </SuperRow>
          </Contentstyled>
          <MyFooter />
        </Layout>
      );
  }
}

const mapStateToProps = globalReducers => globalReducers;
const connectedLandingHome = connect(
  mapStateToProps,
  null
)(LandingHome);
export default connectedLandingHome;
